import { useEffect } from "react";

import sendGaGtmEvent, {
  GA_GTM_EVENT_NAMES,
} from "web/utils/system/GTM/sendGaGtmEvent";

const CTA_BUTTON_SELECTOR = `a[data-gtm="${GA_GTM_EVENT_NAMES.CTA_BUTTON}"]`;

const useCtaButtonGtmClickTracking = (isEnabled: boolean) => {
  useEffect(() => {
    if (!isEnabled) return undefined;

    const handleClick = (event: MouseEvent) => {
      const target = (event.target as HTMLElement)?.closest?.(
        CTA_BUTTON_SELECTOR
      ) as HTMLAnchorElement | null;

      if (!target) return;

      sendGaGtmEvent({
        gtmEventName: GA_GTM_EVENT_NAMES.CTA_BUTTON,
        eventCategory: "",
        eventAction: target.textContent?.trim() || "",
        eventLabel: target.href,
      });
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [isEnabled]);
};

export default useCtaButtonGtmClickTracking;
